// ── Shared Configuration Constants ──
// Centralized config to prevent scatter across files

// ── Auto-Save ──
export const AUTO_SAVE_DELAY_MS = 2000;

// ── Time Ranges ──
export const TIME_RANGES: Record<
  string,
  { start: number; end: number; label: string }
> = {
  morning: { start: 360, end: 720, label: "morning (6 AM - 12 PM)" }, // 6:00 - 12:00
  afternoon: { start: 720, end: 1020, label: "afternoon (12 PM - 5 PM)" }, // 12:00 - 17:00
  evening: { start: 1020, end: 1380, label: "evening (5 PM - 11 PM)" }, // 17:00 - 23:00
};

// ── Travel Estimation ──
export const WALK_THRESHOLD_KM = 1;
export const WALK_SPEED_KMH = 5;
export const DRIVE_SPEED_KMH = 50;
export const MAX_REASONABLE_DRIVE_KM = 300; // ~185 miles, ~6 hours - beyond this, you'd fly/train

// ── Color Palette ──
export const PALETTE_SIZE = 8;

// ── Places API ──
export const PLACES_SEARCH_DEBOUNCE_MS = 300;
export const PLACES_RATE_LIMIT_PER_MIN = 100; // Loose limit to catch runaway loops
